import browser from '@openclassrooms/utils/browser';
import { getStore } from 'Modules/store';
import { updateNotifications } from './actions';
import display from './display';
import disclaimerMessages from './disclaimerMessages';
import flashMessages from './flashMessages';
import reducers from './reducers';

export { default as popFlashMessage } from './flashMessages/popMessage';
export { reducers };

function getStaticNotifications() {
  return browser.window.App.notifications;
}

function dispatchStaticNotificationsCount(dispatch) {
  dispatch(updateNotifications(getStaticNotifications()));
}

export function notifications() {
  const { dispatch } = getStore();
  dispatchStaticNotificationsCount(dispatch);

  display();
  flashMessages();
  disclaimerMessages();
}

export default notifications;
